import React from "react";
import ComingSoonList from "../../../containers/ComingSoonList";

const ComingSoonListPage = () => {
  return (
    <>
      <div>
        <ComingSoonList />
      </div>
    </>
  );
};

export default ComingSoonListPage;
